import styled from "styled-components";

export const DirectionItem = styled("li")(({ theme }) => ({
  marginBottom: 8,

  "& a": {
    color: theme.palette.secondary.lighter,
    textDecoration: "none",
    padding: "8px 12px",
    borderRadius: 6,
    display: "block",
    transition: "background-color 0.2s ease",

    "&:hover": {
      backgroundColor: theme.palette.gray[50],
      color: theme.palette.secondary.dark,
    },
  },
}));

export const DirectionList = styled("ul")(({ theme }) => ({
  listStyle: "none",
  padding: 0,
  margin: 0,

  display: "grid",
  gridTemplateColumns: "repeat(3,1fr)",
  gap: 20,

  [theme.down("xs")]: {
    gridTemplateColumns: "repeat(2,1fr)",
  },
}));
